import { PAGE_TITLES } from './constants';

/**
 * Derive the display title for the current route pathname.
 * Falls back to a prefix match for nested routes, then a generic title.
 */
export const getPageTitle = (pathname) => {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  const match = Object.entries(PAGE_TITLES).find(([path]) =>
    pathname.startsWith(path + '/')
  );
  return match ? match[1] : 'Talk to Ticket';
};

/**
 * Return up to two uppercase initials from a full name string.
 */
export const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
};